<h2 class="page-heading">View Message By Queue</h2>

<div class="table-container ">

  <div class="filters ">
    <!--LOB if not telecom admin, hide this and use activeLOB from config-->
    <select 
      class="custom-select"
      *ngIf="auth.memberOf.includes(telecomRole)"
      [(ngModel)]="lobSelect" 
      (ngModelChange)="filterGroups(); filterQueues(); groupSelect = 'DEFAULT'; queueSelect = 'DEFAULT'; showMessageTable = false; queueLangCode = defaultLang;">
        <option class="custom-option" selected hidden ngValue="DEFAULT">Select LOB</option>
        <option class="custom-option" *ngFor="let lob of lobList" [ngValue]="lob[1]">{{lob[0]}}</option>
    </select>

    <!--Group-->
    <select
    class="custom-select" 
      [(ngModel)]="groupSelect" 
      (ngModelChange)="getGroupMessages(); filterQueues(); queueSelect = 'DEFAULT'; showMessageTable = false;" 
      [disabled]="lobSelect == 'DEFAULT'"
      >
        <option class="custom-option" selected hidden ngValue="DEFAULT">Select Group</option>
        <option class="custom-option" ngValue="NoFilter">All Queues</option>
        <option class="custom-option" ngValue="NoGroup">Queues Without Group</option>
        <option class="custom-option" *ngFor="let group of filteredGroups" [ngValue]="group.groupId">{{group.groupName}}</option>
    </select>
    
    <!--Queue-->
    <select 
      class="custom-select"
      [(ngModel)]="queueSelect" 
      (ngModelChange)="getQueueMessages(); setQueueLang(); showMessageTable = false;" 
      [disabled]="lobSelect == 'DEFAULT'"
      >
      <option class="custom-option" selected hidden ngValue="DEFAULT">Select Queue</option>
      <option class="custom-option" *ngFor="let queue of filteredQueues" [ngValue]="queue.queueId">{{queue.queueName}}</option>
    </select>
    <br>

    <span *ngIf="queueSelect != 'DEFAULT'" class="lang-display">
      Queue Language: {{queueLanguage}}
    </span>
    
  </div>
  <br>

  <!--Page notifications-->
  <app-response-text
    [lambdaMessage]="pageMessage"
    [lambdaError]="pageError">
  </app-response-text>

  <!--Group Message Grid (view only)-->
  <div *ngIf="groupSelect != 'DEFAULT' && groupSelect != 'NoFilter' && groupSelect != 'NoGroup'">
    <app-data-grid
      [data]="groupMessages"
      [columnNames]="['Message Type', 'Message Title', 'Message', 'Start Date', 'Start Time', 'End Date', 'End Time', 'Last Updated', 'Updated By']"
      [spacing]="[10, 10, 20, 8, 8, 8, 8, 10, 10, 8]"
      [viewTemplate]="standardView"
      [headerTemplate]="groupHeader"
      [footerTemplate]="footer"
      [itemsPerPage]="5"
      [allowEdit]="false"
      [allowAdd]="false"
      [allowDelete]="false"
      >
      <ng-template #groupHeader>
        <span class="lefty">Group Messages</span>
      </ng-template>
    </app-data-grid>

  </div>
  <br>

  <div *ngIf="queueSelect != 'DEFAULT'">

    <!--Queue Message Notification-->
    <app-response-text
      [lambdaMessage]="queueMessage"
      [lambdaError]="queueError">
    </app-response-text>

    <!--Queue Message Grid-->
    <app-data-grid
      [(data)]="queueMessages"
      (dataChange)="this.filterMessages(typeSelect);"
      (buttonEvent)="handleButtonEvent($event); queueError = false; queueMessage = ''; pageError = false; pageMessage = '';"
      (itemChange)="updateMessage($event);"
      [(isValid)]="formValid"
      [columnNames]="['Message Type', 'Message Title', 'Message', 'Start Date', 'Start Time', 'End Date', 'End Time', 'Last Updated', 'Updated By']"
      [spacing]="[10, 10, 20, 8, 8, 8, 8, 10, 10, 8]"
      [viewTemplate]="standardView"
      [formTemplate]="formView"
      [headerTemplate]="queueHeader"
      [footerTemplate]="footer"
      [severAdd]="true"
      [itemsPerPage]="5"
      >
      <ng-template #queueHeader>
        <span class="lefty">Queue Specific Messages</span>
      </ng-template>

    </app-data-grid>
    <br>

    <!--hide/show add message elements-->
    <div *ngIf="showMessageTable">

      <!--Message Grid Notifications-->
      <app-response-text
        [lambdaMessage]="messageMessage"
        [lambdaError]="messageError">
      </app-response-text>

      <select class="custom-select  table-select lefty" [(ngModel)]="messageTypeSelect" (ngModelChange)="filterMessages();">
        <option class="custom-option" selected ngValue="NoFilter">No Filter</option>
        <option class="custom-option" *ngFor="let type of messageTypes" [ngValue]="type">{{type}}</option>
      </select>
      <br>
      <br>
      <br>

      <!--Message Grid-->
      <app-data-grid
        [data]="filteredMessages"
        (buttonEvent)="messageError = false; messageMessage = ''"
        (itemChange)="addMessageToQueue($event);"
        [columnNames]="['Message Type', 'Message Title', 'Message', 'Start Date', 'Start Time', 'End Date', 'End Time']"
        [spacing]="[10, 10, 20, 8, 8, 8, 8, 8]"
        [viewTemplate]="messageView"
        [allowEdit]="false"
        [allowAdd]="false"
        [allowDelete]="false"
        [customButtons]="{'add': 'addbtn'}"
        [itemsPerPage]="5"
        >
      </app-data-grid>
      <br>
    </div>
  </div>

  <!--Standard View (for group and queue)-->
  <ng-template #standardView let-item>
    <td><div class="cell">{{item.message.messageType}}</div></td>
    <td><div class="cell">{{item.message.messageTitle}}</div></td>
    <td><div class="cell">{{getMessageText(item)}}</div></td>
    <td><div class="cell">{{timeService.unitedStatesFormat(item.messageDuration.messageStartDate)}}</div></td>
    <td><div class="cell">{{item.messageDuration.messageStartTime}}</div></td>
    <td><div class="cell">{{timeService.unitedStatesFormat(item.messageDuration.messageEndDate)}}</div></td>
    <td><div class="cell">{{item.messageDuration.messageEndTime}}</div></td>
    <td><div class="cell">{{item.lastUpdated}}</div></td>
    <td><div class="cell">{{item.updatedBy}}</div></td>
  </ng-template>

    <!--Edit-->
    <ng-template #formView let-item>
      <td><div class="cell">{{item.message.messageType}}</div></td>
      <td><div class="cell">{{item.message.messageTitle}}</div></td>
      <td><div class="cell">{{getMessageText(item)}}</div></td>
      <td><input type="date" 
        [(ngModel)]="item.messageDuration.messageStartDate" 
        (ngModelChange)="item.messageDuration.messageEndDate = item.messageDuration.messageStartDate; validate(item);">
      </td>
      <td><input type="time" [(ngModel)]="item.messageDuration.messageStartTime" (ngModelChange)="validate(item);"></td>
      <td><input type="date" [(ngModel)]="item.messageDuration.messageEndDate" (ngModelChange)="validate(item);" ></td>
      <td><input type="time" [(ngModel)]="item.messageDuration.messageEndTime" (ngModelChange)="validate(item);"></td>
      <td><div class="cell">{{item.lastUpdated}}</div></td>
      <td><div class="cell">{{item.updatedBy}}</div></td>
    </ng-template>

  <!--Message View-->
  <ng-template #messageView let-item>
    <td><div class="cell">{{item.message.messageType}}</div></td>
    <td><div class="cell">{{item.message.messageTitle}}</div></td>
    <td><div class="cell">{{getMessageText(item)}}</div></td>
    <td><div class="cell">{{timeService.unitedStatesFormat(item.messageDuration.messageStartDate)}}</div></td>
    <td><div class="cell">{{item.messageDuration.messageStartTime}}</div></td>
    <td><div class="cell">{{timeService.unitedStatesFormat(item.messageDuration.messageEndDate)}}</div></td>
    <td><div class="cell">{{item.messageDuration.messageEndTime}}</div></td>
  </ng-template>

  <!--missing message notification-->
  <ng-template #footer>
    <!-- <span *ngIf="queueLanguage != null" class="lefty warning">* Missing {{queueLanguage}} version of the message.</span> -->
  </ng-template>

</div>